export enum FlagTypes {
  EDI = 'isEdi',
  BKM = 'isBkm',
  FFA = 'isFfa',
  GEMA = 'isGema',
  SPIO = 'isSpio'
}